module.exports = __webpack_public_path__ + "img/990.daee3f29.png";